import React from 'react'
import { ListNav, List } from '.'
import { ListFilter, FloatingFilter } from '../../../components'
import dummyData from '../data'

const MainContentMobile = () => {
  const [selected, setSelected] = React.useState('Program')
  const [filtered, setFiltered] = React.useState(false)
  const [data, setData] = React.useState(dummyData.program)

  React.useEffect(() => {
    if(filtered){
      setData(dummyData[selected.toLowerCase()].slice(0, 3))
    }else{
      setData(dummyData[selected.toLowerCase()])
    }
  }, [filtered, selected])

  return (
    <div>
      <ListNav selected={selected} onChange={setSelected} mobile/>
      <div className="md:hidden">
        <ListFilter filtered={filtered} setFiltered={setFiltered}/>
      </div>
      <div className="hidden md:block container mx-auto">
        <ListFilter filtered={filtered} setFiltered={setFiltered}/>
      </div>
      <div className="container mx-auto">
        <List selected={selected} data={data}/>
      </div>
      <FloatingFilter onSubmit={() => setFiltered(true)}/>
    </div>
  )
}

export { MainContentMobile }
